import { memo } from "react";
import { connect } from "react-redux";
import * as reducers from "../../reducers";
import * as actions from "../../reducers/actions";
import Header from ".";

const mapStateToProps = (state) => ({
  loggedUser: reducers.getLoggedUser(state),
});

const mapDispatchToProps = {
  signOut: actions.signOutEffect,
};

export default memo(connect(mapStateToProps, mapDispatchToProps)(Header));
